import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrderTypeProgress = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.3068 10.2989L10.5377 13.548C10.4243 13.7555 10.2093 13.8739 9.9885 13.8739C9.88683 13.8739 9.78516 13.8497 9.68933 13.798C9.38683 13.6322 9.27433 13.253 9.44016 12.9497L10.706 10.6247H8.24183C8.021 10.6247 7.81683 10.5089 7.70433 10.3189C7.59183 10.1297 7.58683 9.89552 7.69183 9.70136L9.45933 6.44967C9.62433 6.14551 10.0043 6.03467 10.3068 6.19884C10.6102 6.36301 10.7227 6.74301 10.5577 7.04634L9.29266 9.37469H11.7577C11.9785 9.37469 12.1827 9.49136 12.2952 9.68052C12.4077 9.86969 12.4118 10.1055 12.3068 10.2989ZM10.0002 2.08301C5.63516 2.08301 2.0835 5.63467 2.0835 9.99969C2.0835 14.3647 5.63516 17.9164 10.0002 17.9164C14.366 17.9164 17.9168 14.3647 17.9168 9.99969C17.9168 5.63467 14.366 2.08301 10.0002 2.08301Z",
		fill: "currentColor"
	})
});
export default SvgOrderTypeProgress;
